
import React from 'react';
import { Badge, Tooltip, theme } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';

export const ChosenByClientBadge = ({ isChosenByClient, children, size = 'default' }) => {
  const { token: themeToken } = theme.useToken();

  if (!isChosenByClient) return children; // Si no es elegido por el cliente, no se muestra el badge

  const isSmall = size === 'small'

  return (
    <Badge.Ribbon
      placement='start'
      text={
        <Tooltip title='Plan elegido por el cliente'>
          <FontAwesomeIcon icon={faUser} style={{ padding: isSmall ? '2px 4px' : '3px 8px' }} />
        </Tooltip>
      }
      color={themeToken.colorPrimary}
      style={{
        padding: 0,
        lineHeight: 1,
        ...(isSmall && {
          top: 4,
          fontSize: '0.8em',
        }),
      }}
    >
      {React.isValidElement(children)
        ? React.cloneElement(children, {
          style: {
            borderColor: themeToken.colorPrimary, // Aplica el color de borde al componente hijo
            ...(children.props.style ?? {}),
          },
        })
        : children}
    </Badge.Ribbon>
  );
};